// client/src/admin/resources/servizi.js
import * as React from 'react';
import { List, Datagrid, TextField, BooleanField, NumberField, EditButton, DeleteButton,
         Edit, SimpleForm, TextInput, BooleanInput, NumberInput, Create, ReferenceInput, SelectInput, required } from 'react-admin';

export const ServizioList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="id_fornitore" />
      <TextField source="descrizione_capo" />
      <BooleanField source="lavaggio" />
      <BooleanField source="stiratura" />
      <NumberField source="prezzo" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const ServizioEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="id_fornitore" validate={[required()]} />
      <TextInput source="descrizione_capo" validate={[required()]} />
      <BooleanInput source="lavaggio" />
      <BooleanInput source="stiratura" />
      <NumberInput source="prezzo" validate={[required()]} />
    </SimpleForm>
  </Edit>
);

export const ServizioCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="id_fornitore" validate={[required()]} />
      <TextInput source="descrizione_capo" validate={[required()]} />
      <BooleanInput source="lavaggio" />
      <BooleanInput source="stiratura" />
      <NumberInput source="prezzo" validate={[required()]} />
    </SimpleForm>
  </Create>
);
